import request from '@/utils/request'

// 获取公共计划
export function getPublicplan(params = {}) {
  return request({
    url: `/ad_management/campaigns`,
    method: 'get',
    params
  })
}

// 获取账号计划
export function getAccountsPlan(params = {}) {
  return request({
    url: `/ad_management/campaign_accounts`,
    method: 'get',
    params
  })
}

export function getCommodity(id = null) {
  return request({
    url: id ? `/account_management/get_list?id=${id}` : '/account_management/get_list',
    method: 'get'
  })
}

export function create_adq({ account_id, campaign_primary_id }) {
  return request({
    url: `/account_management/campaign/create_adq`,
    method: 'post',
    data: {
      account_id,
      campaign_primary_id
    }
  })
}

export function enumerationF() {
  return request({
    url: `/condition_config/enumerations?api_name=campaigns/get`,
    method: 'get'
  })
}

export function getDetails(id) {
  return request({
    url: `/ad_management/campaign/common_detail?campaign_primary_id=${id}`,
    method: 'get'
  })
}

export function createPublicPlan(data = {}) {
  return request({
    url: `/ad_management/campaigns`,
    method: 'post',
    data
  })
}

// 更新推广计划
export function updatePlan(campaign_id, data = {}) {
  return request({
    url: `/ad_management/campaign_accounts/${campaign_id}`,
    method: 'PUT',
    data
  })
}

// 删除推广计划
export function deletePlan(campaign_id, data = {}) {
  return request({
    url: `/ad_management/campaign_accounts/${campaign_id}`,
    method: 'DELETE',
    data
  })
}

// 添加推广计划
export function addPlan(data = {}) {
  return request({
    url: `/ad_management/campaign_accounts`,
    method: 'post',
    data
  })
}
// 添加推广计划
export function addPweqweq(data = {}) {
  return request({
    url: `/landingPageH5/create`,
    method: 'post',
    data
  })
}
// 添加更新
export function PageH5update(data = {}) {
  return request({
    url: `/landingPageH5/update`,
    method: 'post',
    data
  })
}
// 添加列表
export function landingPageH5index(params = {}) {
  return request({
    url: `/landingPageH5/index`,
    method: 'get',
    params
  })
}
// 删除
export function landingPageH5destroy(data = {}) {
  return request({
    url: `/landingPageH5/destroy`,
    method: 'post',
    data
  })
}
// 删除
export function landingPageH5setAuditStatus(data = {}) {
  return request({
    url: `/landingPageH5/setAuditStatus`,
    method: 'post',
    data
  })
}
// 添加列表
export function landingPageH5memberlist(params = {}) {
  return request({
    url: `/landingPageH5/member_list`,
    method: 'get',
    params
  })
}
// 列表
export function landingPageH5memberdetails(params = {}) {
  return request({
    url: `/landingPageH5/member_details`,
    method: 'get',
    params
  })
}
